
import { Visual }      from './visual';
import { FontVariant } from '@/helpers/fonts/font.variant';
import { FontStyle }   from '@/helpers/fonts/font.style';
import { FontWeight }  from '@/helpers/fonts/font.weight';

/** test if the interface we have is a Text */
export function isText(obj: any): obj is Text {

  return (obj as Text).isText !== undefined;
}

/**
 *
 * @class Text
 *
 * specifies how to render a text label
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export interface Text extends Visual {

  /** type guard */
  isText: () => void;

  /** horizontal position */
  x?: number;

  /** vertical position */
  y?: number;

  /** horizontal extend */
  width?:           number;

  /** vertical extent */
  height?:          number;

  /** the text to render */
  text?: string;

  /** font family to use */
  family?: string;

  /** text height */
  size?: number;

  /** fill color */
  color?: string;

  /** how heavy? */
  weight?: FontWeight;

  /** small-caps? */
  variation?: FontVariant;

  /** italic? */
  style?: FontStyle;

  /** drawn or not */
  visible?: boolean;

  /** transparency (transparent) 0.0 ... 1.0 (not transparent) */
  opacity?: number;

  /** degrees to rotate the text */
  rotation: number;

}
